// extracted by mini-css-extract-plugin
export var form = "RequestAccess-module--form--2f253";
export var message = "RequestAccess-module--message--ac985";
export var section = "RequestAccess-module--section--2e5bf";
export var subheading = "RequestAccess-module--subheading--ea0d3";
export var title = "RequestAccess-module--title--2c03e";